import { updateFundingEnquiryStatus } from './types';
export * from './actions';

const updateFundingEnquiryStatusReducerObject = {
  [updateFundingEnquiryStatus.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['updateStatus', 'network', 'error'], true)
        .setIn(['updateStatus', 'network', 'loading'], false),
    ),
  [updateFundingEnquiryStatus.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['updateStatus', 'network', 'error'], false)
        .setIn(['updateStatus', 'network', 'loading'], true),
    ),
  [updateFundingEnquiryStatus.success]: (state, { data }) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['byId', data.id, 'status'], data.status)
        .setIn(['updateStatus', 'network', 'error'], false)
        .setIn(['updateStatus', 'network', 'loading'], false),
    ),
};

export default updateFundingEnquiryStatusReducerObject;
